<template>
  <div id="app">
    <!-- <v-header></v-header> -->
    <router-view v-if="isShow" />
    <!-- <item7></item7> -->
  </div>
</template>

<script>
  import vHeader from './components/vHeader.vue'
  import item7 from './components/item7.vue'
  export default {

    name: 'App',
    components: {
      vHeader,
      item7,
    },
    provide() {
      return {
        reload: this.reload
      }
    },
    data() {
      return {
        isShow: true
      }

    },
    methods: {
      reload() {
        this.isShow = false;
        this.$nextTick(() => {
          this.isShow = true
        })
      }
    }
  }
</script>

<style>
  #app {
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    z-index: 0;
    /* background-color: #f5f7fa; */
    /* width: 1280px; */
  }

  li {
    list-style: none;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue